import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div`
  position: relative;
  width: 100%;
`;
export const FooterContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'center',
    direction: 'row',
    wrap: 'nowrap',
  })};
  height: 50px;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-top-left-radius: 4px;
  border-bottom: 0;
`;
export const FooterTitle = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'left',
    weight: 400,
  })};
`;

export const AppVersionTitle = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'left',
    weight: 400,
  })};
  margin-left: 4px;
`;
